<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>141-2.1.3.1.1 питание (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form >
        <div class="table-container">

          <table class="grid-table">
            <thead>
            <tr>
              <th  class="title-cell">Наименование</th>
              <th >Среднее количество питающихся в день (единиц)</th>
              <th>Дни функционирования учреждения (дни)</th>
              <th>Норма питания на 1 единицу в день*</th>
              <th>Расчетная сумма затрат</th>
              <th>Фактическая сумма затрат</th>
            </tr>  
            </thead>
            <tbody>
            <tr class="total-row calculated-row readonly-text">
              <td>ВСЕГО</td>
              <td>{{ dto.averageDailyConsumers }}</td>
              <td>{{ dto.operatingDays }}</td>
              <td>{{ dto.dailyFoodNormPerUnit }}</td>
              <td>{{ dto.calculatedSum }}</td>
              <td>{{ dto.actualSum }}</td>
            </tr>
            <template v-for="month in dto.months">
              <tr>
                <td>
                  {{ months[month.month - 1] }}
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.averageDailyConsumers" type="number"                            @input="recalculate( 'averageDailyConsumers')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.operatingDays" type="number"                            @input="recalculate( 'operatingDays')"/>
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.dailyFoodNormPerUnit" type="number"                            @input="recalculate( 'dailyFoodNormPerUnit')"/>
                </td>
                <td class="expense-sum-edit">
                  {{month.calculatedSum}}
                </td>
                <td class="expense-sum-edit">
                  <el-input v-model="month.actualSum" type="number"                            @input="recalculate( 'actualSum')"/>
                </td>
              </tr>
            </template>

            </tbody>

          </table>
        </div>


      </form>
      </el-card>
  </div>


  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import authService from "@/services/authService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";

export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    }
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'nutrition',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        months: []
      },
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
    };
  },
  methods: {
    init() {
      this.findById(this.uuid);
    },

    async findById(uuid) {
      this.isLoading = true;
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.sortByCatAndMonth();
      this.isLoading = false;
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) {
          return;
        }

        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.sortByCatAndMonth();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    sortByCatAndMonth() {
      if (!this.dto.months) {
        return;
      }

      this.recalculate( 'averageDailyConsumers');
      this.recalculate( 'operatingDays');
      this.recalculate( 'dailyFoodNormPerUnit');
      // this.recalculate( 'calculatedSum');
      this.recalculate( 'actualSum');


      if (this.dto.months && this.dto.months.length > 0) {
        this.dto.months.sort((a, b) => a.month - b.month);
      }
    },

    goBack()  {
      this.$router.go(-1);
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED'  || !this.dto.status);
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
     recalculate(fieldName) {
        if (!this.dto.months || this.dto.months.length === 0) return;
        for (const item of this.dto.months) {
          item.calculatedSum = parseFloat(item.averageDailyConsumers || 0) *
            parseFloat(item.operatingDays || 0) *
            parseFloat(item.dailyFoodNormPerUnit || 0);
        }



       this.dto[fieldName] = this.dto.months.reduce((sum, c) => sum + parseFloat(c[fieldName] || 0), 0);
       this.dto.calculatedSum = this.dto.months.reduce((sum, i) => sum + parseFloat(i.calculatedSum || 0), 0);
     }

  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

table.expenses-detail tr td {
  padding: 0 !important;
  padding-left: 5px !important;
  font-size: 14px;
}
table.expenses-detail tr td.expense-sum-edit:has(.form-control){
  padding-left: 0 !important;
}

table.expenses-detail tr td.expense-sum-edit .form-control {
  padding-left: 2px !important;
  font-size: 14px !important;
}
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 1200px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 13px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.title-cell { width: 250px; }
.color-red, .color-red:hover {  color: red !important;}
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
::v-deep .el-input__inner { text-align: right; font-size: 13px; }
.total-row td {
  font-weight: bold;
}
</style>
